import { useFlag } from '@calendly/feature-check-react'
import { MailSendEnvelopeIcon } from '@calendly/ui/components/icons'

import { useToggleState } from 'hooks/useToggleState'

import { Wrapper,
  Container,
  Row,
  InfoContainer } from '../styles'
import { CrmExternalInvitee } from './crm_external_invitee'
import { LegacyExternalInvitee } from './legacy_external_invitee'
import { FullStoryMask } from '../../../../../../../shared/fullstory_privacy'

export const ExternalInvitee = ({ invitee }) => {
  const [isOpen, toggle] = useToggleState(false)

  const { email, kind, rsvp } = invitee
  const cancelled = rsvp === 'declined'
  const isHost = kind === 'HOST'


  const isCRMContactsPageEnabled = useFlag('crm_contacts_page_to_ai_crm_feature')
  const ExternalInviteeComponent = isCRMContactsPageEnabled ? CrmExternalInvitee : LegacyExternalInvitee

  return (
    <Wrapper>
      <Container>
        <ExternalInviteeComponent
          cancelled={cancelled}
          isHost={isHost}
          invitee={invitee}
          toggle={toggle}
        />
      </Container>
      {isOpen && (
        <InfoContainer>
          <Row>
            <MailSendEnvelopeIcon spacingRight={8} />
            <span><FullStoryMask>{email}</FullStoryMask></span>
          </Row>
        </InfoContainer>
      )}
    </Wrapper>
  )
}
